<template>
  <div class="resources-access">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <login-layout v-if="!loading">
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <gappt-menu class="ma-4" :user="user"></gappt-menu>
      </v-row>
      <div class="pa-6">
        <v-row class="display-1" justify="center">
          Manage Application Access
        </v-row>

        <v-list>
          <v-text-field
            placeholder="Filter resources"
            v-if="resources.length > minSearchAccounts"
            v-model="delayedFilter"
            prepend-icon="search"
            type="text"
            color="primary darken-4"
            autofocus
          ></v-text-field>
          <div v-else class="mb-6"></div>
          <div v-for="(resource, index) in filtered" :key="index">
            <v-divider v-if="index!==0"></v-divider>

            <v-list-item @click="selectResource(resource)">
              <v-list-item-avatar>
                <v-icon v-if="!icon(resource)">business</v-icon>
                <v-img v-if="icon(resource)"
                       :lazy-src="icon(resource)"
                       :src="icon(resource)"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="resource.title"></v-list-item-title>
                <v-list-item-subtitle>
                  {{resource.sub_title}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list>
        <div class="d-flex justify-end">
          <v-chip outlined small v-if="resources.length>10 || resources.length !== filtered.length" color="primary darken-4" text-color="primary darken-4">
            Total {{resources.length}} accounts.
            <template v-if="filter.length">{{accountsFound}}</template>
          </v-chip>
        </div>

      </div>

      <v-dialog
        v-model="modalFrom"
        scrollable
        max-width="800px">
        <v-card>
          <v-card-title>
            Set access for {{ activeResource?activeResource.title:'' }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 400px;">
            <v-container>
              <v-row>
                <v-col cols="4" v-for="(application, index) in applications" :key="index">
                    <v-switch
                      @change="setApplicationResourceAccess($event, application.id)"
                      v-model="access[application.id][activeResource.id]"
                      :loading="beingSent == application.id + '-' + activeResource.id"
                      inset
                      :label="application.name"
                    ></v-switch>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="modalFrom = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="error" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Error</v-card-title>
          <v-card-text>
            {{ errorMessage }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="error = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </login-layout>
  </div>
</template>
<script>
    import GapptMenu from "./Menu";

    export default {
        name: "ResourcesAccess",

        components: { GapptMenu },

        data() {
            return {
                modalFrom: false,
                activeResource: {},
                beingSent: null,
                user: {},
                resources: [],
                applications: [],
                applicationResources: [],
                access: [],
                minSearchAccounts: 10,
                filter: '',
                timeout: null,
                delayedFilter: '',
                error: false,
                errorMessage: '',
            }
        },

        computed: {
            loading () {
                return this.$store.state.loading
            },

            filtered() {
                let filter = this.filter.trim().length ? this.filter.toLowerCase().split(' ') : [];
                const limit = filter.length ? 100 : 10;
                return this.resources
                    .filter(resource => {
                        return !filter.length
                            || filter.every(term => {
                                return (resource.title || '').toLowerCase().indexOf(term) > -1
                                    || (resource.sub_title || '').toLowerCase().indexOf(term) > -1;
                            });
                    })
                    .slice(0, limit);
            },

            accountsFound() {
                switch (this.filtered.length) {
                    case 0:
                        return 'No accounts found';
                    case 1:
                        return 'Found one account';
                    default:
                        return `Found ${this.filtered.length} accounts`;
                }
            }
        },

        watch: {
            delayedFilter(val) {
                if (this.timeout) clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.filter = val;
                }, 600);
            },
        },

        mounted() {
            this.getData()
        },

        methods: {
            async setApplicationResourceAccess(values, applicationId) {
                this.beingSent = applicationId + '-' + this.activeResource.id
                await this.$resourceService.setAccess(this.activeResource.id, this.activeResource.type_id, applicationId, values).catch(
                    (error) => {
                        this.error = true
                        this.errorMessage = error.response.data.error
                        this.access[applicationId][this.activeResource.id] = !values
                    }
                ).
                finally(
                    ()=> this.beingSent = null
                );
            },

            selectResource(resource) {
                this.modalFrom = true
                this.activeResource = resource
            },

            accessSetup() {
                for (let key in this.applications) {
                    if (typeof this.access[this.applications[key].id] == 'undefined') {
                      this.access[this.applications[key].id] = []
                    }
                    for (let key_ in this.resources) {
                      this.access[this.applications[key].id][this.resources[key_].id] = false
                    }
                }

                for (let key__ in this.applicationResources) {
                      this.access[this.applicationResources[key__].application][this.applicationResources[key__].resource] = true
                }
            },

            async getData() {
                this.$store.commit('loadingOn')

                return await this.$sessionService.current().then(
                    response => {
                        this.user = response.login
                        if (this.user.admin) {
                            Promise.all([
                                this.getResources(),
                                this.getApplications(),
                                this.getAccess(),
                            ]).then(()=>this.accessSetup())
                              .finally(() => this.$store.commit('loadingOff'));
                        } else {
                            this.$router.replace({name: 'home'})
                        }
                    }).catch((error) => {
                        this.$router.replace({name: 'login'})
                        throw error
                    })
            },

            async getResources() {
                this.resources = await this.$resourceService.getResources();
            },

            async getApplications() {
                this.applications = await this.$resourceService.getApplications();
            },

            async getAccess() {
                this.applicationResources = await this.$resourceService.getAccess();
            },

            icon(resource) {
                switch (resource.type) {
                    case 'core':
                        return this.$api.url('/icons/' + resource.id);
                    default:
                        return resource.icon;
                }
            }
        }
    }
</script>

<style scoped>
.v-avatar {
  background-color: #e0e0e0;
}
</style>